import React from 'react';
import PropTypes from 'prop-types';

function Search(props) {
  const {
    searchTerm,
    onSearchChange,
  } = props;

  return (
    <div className="contact-search-form">
      <input
        type="text"
        className="form-control"
        placeholder="Search"
        value={searchTerm}
        onChange={onSearchChange}
      />
      <button type="button">
        <i className="fa-solid fa-magnifying-glass" />
      </button>
    </div>
  );
}

Search.propTypes = {
  searchTerm: PropTypes.string.isRequired,
  onSearchChange: PropTypes.func.isRequired,
};

export default Search;
